import { useState } from 'react';
import { useDevice } from '../store';
import type { DeviceRole } from '@taj/types';

const ROLES: { role: DeviceRole; icon: string; label: string; desc: string }[] = [
  { role: 'KIOSK', icon: '🛎️', label: 'Borne', desc: 'Commande client (tablette portrait)' },
  { role: 'CASHIER', icon: '💳', label: 'Caisse', desc: 'Encaissement & suivi' },
  { role: 'KDS', icon: '👨‍🍳', label: 'Cuisine (KDS)', desc: 'Écran de poste' },
  { role: 'DISPLAY', icon: '📺', label: 'Écran salle', desc: 'Commandes prêtes' },
  { role: 'PICKUP', icon: '🛍️', label: 'Comptoir / Retrait', desc: 'Remise des commandes' },
  { role: 'BACKOFFICE', icon: '🛡️', label: 'Back-office', desc: 'Manager / Admin' },
];

const STATIONS = ['Thaï', 'Indien', 'Naan'];

export function RoleSelect() {
  const setRole = useDevice((s) => s.setRole);
  const [pickStation, setPickStation] = useState(false);

  if (pickStation) {
    return (
      <div className="role-wrap">
        <div className="role-brand">TAJ FUSION</div>
        <div className="staff-subtitle">Choisissez le poste cuisine de cet écran</div>
        <div className="role-grid">
          {STATIONS.map((st) => (
            <button key={st} className="role-btn" onClick={() => setRole('KDS', st)}>
              <span className="role-ic">👨‍🍳</span>
              <span className="role-lbl">{st}</span>
            </button>
          ))}
        </div>
        <button className="linkbtn" onClick={() => setPickStation(false)}>← Retour</button>
      </div>
    );
  }

  return (
    <div className="role-wrap">
      <div className="role-brand">TAJ FUSION</div>
      <div className="staff-subtitle">Configurer le rôle de cet appareil</div>
      <div className="role-grid">
        {ROLES.map((r) => (
          <button
            key={r.role}
            className="role-btn"
            onClick={() => (r.role === 'KDS' ? setPickStation(true) : setRole(r.role))}
          >
            <span className="role-ic">{r.icon}</span>
            <span className="role-lbl">{r.label}</span>
            <span className="role-desc">{r.desc}</span>
          </button>
        ))}
      </div>
      <div className="staff-subtitle" style={{ opacity: 0.5 }}>
        Logiciel édité par ecommx solutions
      </div>
    </div>
  );
}
